import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const SchoolWorkspace = lazyPage(() => import('@/pages/school/SchoolWorkspace'));

// Administration · School: the workspace (Overview / Contacts / Calendar /
// Branding tabs) of the school chosen in the header; `:schoolId` opens a named
// school, for old links.
export const schoolRoutes: AppRoute[] = [
  {
    path: 'school',
    title: 'School',
    children: [
      { path: '', title: 'School', component: SchoolWorkspace },
      // Former separate screens, kept so old links and bookmarks still land.
      { path: 'setup', title: 'School', redirectTo: '/administrator/school' },
      { path: 'contacts', title: 'School', redirectTo: '/administrator/school' },
      { path: 'calendar', title: 'School', redirectTo: '/administrator/school' },
      { path: ':schoolId', title: 'School', component: SchoolWorkspace },
    ],
  },
];
